import { useContext, useEffect, useState } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
    useLocation,
    useNavigate
} from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { UserContext } from './UserContext';
import './assets/styles/main.scss';
import './App.css';
import Login from './Login';
import UserList from './UserList';
import UserEdit from './UserEdit';
import Navbar from './Navbar';
import AdminHeader from './Header';
import PublicHeader from './PublicHeader';
import UserAdd from './UserAdd';
import AddCompanyUser from './AddCompanyUser';
import UserListCompany from './UserListCompany';
import CompanyList from './CompanyList';
import CompanyAdd from './CompanyAdd';
import CompanyEdit from './CompanyEdit';
import CompanyReview from './CompanyReview';
import PasswordReset from './PasswordReset';
import TermsConditionsAdmin from './TermsConditionsAdmin';
import CompanyEditHiring from './CompanyEditHiring';
import CountryList from './CountryList';
import CountryAdd from './CountryAdd';
import CountryEditGeneral from './CountryEditGeneral';
import CountryEditVisaStay from './CountryEditVisaStay';
import CountryEditWorkTax from './CountryEditWorkTax';
import CountryEditFinancialsBanks from './CountryEditFinancialsBanks';
import CountryEditHousingLife from './CountryEditHousingLife';
import CountryEditSocial from './CountryEditSocial';
import CountryEditIndustries from './CountryEditIndustries';
import CityAdd from './CityAdd';
import CityList from './CityList';
import CityEdit from './CityEdit';
import CityEditSalary from './CityEditSalary';
import CityEditInsights from './CityEditInsights';
import CityEditUniversities from './CityEditUniversities';
import CityEditCompanies from './CityEditCompanies';
import CityEditJobs from './CityEditJobs';
import CityEditHistory from './CityEditHistory';
import ReportingJobsList from './ReportingJobsList';
import ReportingGeneralList from './ReportingGeneralList';
import ReportingUsersList from './ReportingUsersList';
import ReportingRevenueList from './ReportingRevenueList';
import DonationsList from './DonationsList';
import DonationsMy from './DonationsMy';
import TicketList from './TicketList';
import TicketAdd from './TicketAdd';
import TicketEdit from './TicketEdit';
import { isAdminType, canonicalRole } from './utils/roleUtils';
import { getDiscoveryRedirect } from './utils/discoveryAccess';
import MappingOverview from './MappingOverview';
import MappingIndustries from './MappingIndustries';
import MappingIndustriesView from './MappingIndustriesView';
import MappingSubIndustriesView from './MappingSubIndustriesView';
import MappingOccupation from './MappingOccupation';
import MappingStudyFieldsView from './MappingStudyFieldsView';
import MappingSubSpecialistView from './MappingSubSpecialistView';
import MappingStudyDegreesView from './MappingStudyDegreesView';
import MappingOccupationView from './MappingOccupationView';
import MappingSubOccupationView from './MappingSubOccupationView';
import CompanyEditUsers from './CompanyEditUsers';
import UserEditAcademics from './UserEditAcademics';
import UserEditWorkPreferences from './UserEditWorkPreferences';
import PaymentSuccess from './PaymentSuccess';
import PaymentCancelled from './PaymentCancelled';
import MagicLogin from './MagicLogin';
import PasswordResetToken from './PasswordResetToken';
import UserEditAccess from './UserEditAccess';
import UserEditHistory from './UserEditHistory';
import CompanyEditHistory from './CompanyEditHistory';
import Register from './Register';
import UserOnboarding from './UserOnboarding';
import DiscoveryCompanyList from './components/Discovery/DiscoveryCompanyList';
import DiscoveryCompanyView from './components/Discovery/DiscoveryCompanyView';
import DiscoveryCountryList from './components/Discovery/DiscoveryCountryList';
import DiscoveryCountryView from './components/Discovery/DiscoveryCountryView';
import DiscoveryCountryViewVisa from './components/Discovery/DiscoveryCountryViewVisa';
import DiscoveryCountryViewWorkTax from './components/Discovery/DiscoveryCountryViewWorkTax';
import DiscoveryCountryViewFinancials from './components/Discovery/DiscoveryCountryViewFinancials';
import DiscoveryCountryViewHousing from './components/Discovery/DiscoveryCountryViewHousing';
import DiscoveryCountryViewSocial from './components/Discovery/DiscoveryCountryViewSocial';
import DiscoveryCountryViewIndustries from './components/Discovery/DiscoveryCountryViewIndustries';
import DiscoveryCityList from './components/Discovery/DiscoveryCityList';
import DiscoveryCountryCityList from './components/Discovery/DiscoveryCountryCityList';
import DiscoveryCountryCompanyList from './components/Discovery/DiscoveryCountryCompanyList';
import DiscoveryCityView from './components/Discovery/DiscoveryCityView';
import DiscoveryCityCompanyList from './components/Discovery/DiscoveryCityCompanyList';
import DiscoveryCityViewSalaries from './components/Discovery/DiscoveryCityViewSalaries';
import DiscoveryCityViewInsights from './components/Discovery/DiscoveryCityViewInsights';
import DiscoveryCityViewUniversities from './components/Discovery/DiscoveryCityViewUniversities';
import DiscoveryJobsList from './components/Discovery/DiscoveryJobsList';
import DiscoveryJobsView from './components/Discovery/DiscoveryJobsView';
import DiscoveryCompanyHiringView from './components/Discovery/DiscoveryCompanyHiringView';
import DiscoveryCityJobsList from './components/Discovery/DiscoveryCityJobsList';
import DiscoveryCityViewComments from './components/Discovery/DiscoveryCityViewComments';
import UserProfileAbout from './UserProfileAbout';
import UserProfileAcademics from './UserProfileAcademics';
import UserProfileWorkPreferences from './UserProfileWorkPreferences';
import UserProfileHistory from './UserProfileHistory';
import SupportList from './SupportList';
import SupportView from './SupportView';
import { HeaderActionContext } from './HeaderActionContext';
import MobileAiAssistantProvider from './MobileAiAssistant';
import IncompleteProfileReminder from './components/UserOnboarding/IncompleteProfileReminder';
import Communities from './Communities';
import CommunityView from './CommunityView';

const RequireLoginRedirect = () => {
    const location = useLocation();

    return (
        <Navigate
            to={`/?redirect=${encodeURIComponent(location.pathname + location.search)}`}
            replace
        />
    );
};

const CapacitorDeepLinkHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleUrl = (url) => {
            if (!url) return;

            console.log('CAPACITOR DEEP LINK URL:', url);

            try {
                const incomingUrl = new URL(url);

                if (incomingUrl.pathname === '/magic-login') {
                    navigate(
                        `${incomingUrl.pathname}${incomingUrl.search}`,
                        { replace: true }
                    );
                }
            } catch (err) {
                console.error('Failed to handle app URL:', err);
            }
        };

        // App was launched from a link
        CapacitorApp.getLaunchUrl().then((result) => {
            if (result?.url) {
                handleUrl(result.url);
            }
        });

        // App is already running and receives a link
        const listener = CapacitorApp.addListener('appUrlOpen', ({ url }) => {
            handleUrl(url);
        });

        return () => {
            listener.then(handle => handle.remove());
        };
    }, [navigate]);

    return null;
};

function App() {
    const { user, loading } = useContext(UserContext);
    const [mobileLeftAction, setMobileLeftAction] = useState(null);

    // If user data is still loading, show a spinner or loading screen
    if (loading) {
        return (
            <div className="loading-screen">
                <h2>Loading...</h2>
            </div>
        );
    }

    // Protect admin/superadmin routes and enforce terms agreement
    const requireAgreement = (element) => {
        // ❌ not logged in → login
        if (!user) {
            return <RequireLoginRedirect />;
        }

        // ❌ logged in but not admin/superadmin → login (or some other page if you prefer)
        if (!isAdminType(user.role)) {
            return <Navigate to="/" replace />;
        }

        // ✅ admin, but must agree to terms first
        return user.hasAgreedToTerms
            ? element
            : <Navigate to="/terms-and-conditions-admin" replace />;
    };  

    const requireAuth = (element) => {
        if (!user) {
            return <RequireLoginRedirect />;
        }

        return element;
    };

    // Mirrors the backend's studentAuth middleware: any student role is
    // allowed (including a still-pending registration), everyone else and a
    // blocked registrationStatus are denied.
    const requireStudentAccess = (element) => {
        if (!user) {
            return <RequireLoginRedirect />;
        }

        if (canonicalRole(user.role) !== 'student' || user.registrationStatus === 'blocked') {
            return <Navigate to="/" replace />;
        }

        return element;
    };

    // Mirrors the backend's discoveryAuth (see utils/discoveryAccess): blocked students go to
    // their profile, other roles without Discovery to '/'.
    const requireDiscoveryAccess = (element) => {
        if (!user) {
            return <RequireLoginRedirect />;
        }

        const redirect = getDiscoveryRedirect(user);
        return redirect ? <Navigate to={redirect} replace /> : element;
    };

    const headerClassName =
        user &&
        isAdminType(user.role) &&
        !user.hasAgreedToTerms
            ? 'no-sidebar'
            : '';


    return (
        <>
            <Router>
                <CapacitorDeepLinkHandler />

                <HeaderActionContext.Provider value={{ mobileLeftAction, setMobileLeftAction }}>
                    <MobileAiAssistantProvider>
                    {user
                        ? <AdminHeader headerClassName={headerClassName} />
                        : <PublicHeader />
                    }
                    {user && <IncompleteProfileReminder />}

                    <div className="app-wrapper d-flex">
                        <Navbar />
                        <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/password-reset" element={<PasswordReset />} />
                        <Route path="/password-reset-token" element={<PasswordResetToken />} />

                        {/* User Onboarding */}
                        <Route path="/onboarding" element={<UserOnboarding />} />

                        {/* Terms Agreement */}

                        <Route
                            path="/terms-and-conditions-admin"
                            element={
                                user && isAdminType(user.role) && !user.hasAgreedToTerms ? (
                                    <TermsConditionsAdmin />
                                ) : (
                                    <Navigate to="/onboarding-user-list" />
                                )
                            }
                        />

                        {/* Discovery Routes */}
                        <Route
                            path="/discovery/companies"
                            element={requireDiscoveryAccess(<DiscoveryCompanyList />)}
                        />
                        <Route
                            path="/discovery/companies/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsList />)}
                        />
                        <Route
                            path="/discovery/companies/:id"
                            element={requireDiscoveryAccess(<DiscoveryCompanyView />)}
                        />
                        <Route
                            path="/discovery/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsList />)}
                        />
                        <Route
                            path="/discovery/companies/:id/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />
                        <Route
                            path="/discovery/companies/:id/hiring"
                            element={requireDiscoveryAccess(<DiscoveryCompanyHiringView />)}
                        />

                        <Route
                            path="/discovery/countries"
                            element={requireDiscoveryAccess(<DiscoveryCountryList />)}
                        />
                        
                        <Route
                            path="/discovery/countries/:id"
                            element={requireDiscoveryAccess(<DiscoveryCountryView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/visa-stay"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewVisa />)}
                        />
                        <Route
                            path="/discovery/countries/:id/work-tax"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewWorkTax />)}
                        />
                        <Route
                            path="/discovery/countries/:id/financials"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewFinancials />)}
                        />
                        <Route
                            path="/discovery/countries/:id/housing"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewHousing />)}
                        />
                        <Route
                            path="/discovery/countries/:id/social"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewSocial />)}
                        />
                        <Route
                            path="/discovery/countries/:id/industries"
                            element={requireDiscoveryAccess(<DiscoveryCountryViewIndustries />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities"
                            element={requireDiscoveryAccess(<DiscoveryCountryCityList />)}
                        />
                        <Route
                            path="/discovery/countries/:id/companies"
                            element={requireDiscoveryAccess(<DiscoveryCountryCompanyList />)}
                        />
                        <Route
                            path="/discovery/countries/:id/jobs"
                            element={requireDiscoveryAccess(<DiscoveryCityJobsList countryScoped />)}
                        />
                        <Route
                            path="/discovery/countries/:id/companies/:companyId"
                            element={requireDiscoveryAccess(<DiscoveryCompanyView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/companies/:companyId/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/companies/:companyId/hiring"
                            element={requireDiscoveryAccess(<DiscoveryCompanyHiringView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId"
                            element={requireDiscoveryAccess(<DiscoveryCityView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/companies"
                            element={requireDiscoveryAccess(<DiscoveryCityCompanyList />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/companies/:companyId"
                            element={requireDiscoveryAccess(<DiscoveryCompanyView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/companies/:companyId/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/companies/:companyId/hiring"
                            element={requireDiscoveryAccess(<DiscoveryCompanyHiringView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/companies/jobs"
                            element={requireDiscoveryAccess(<DiscoveryCityJobsList />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/jobs"
                            element={requireDiscoveryAccess(<DiscoveryCityJobsList />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/jobs/:companyId"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/salary"
                            element={requireDiscoveryAccess(<DiscoveryCityViewSalaries />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/insights"
                            element={requireDiscoveryAccess(<DiscoveryCityViewInsights />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/universities"
                            element={requireDiscoveryAccess(<DiscoveryCityViewUniversities />)}
                        />
                        <Route
                            path="/discovery/countries/:id/cities/:cityId/comments"
                            element={requireDiscoveryAccess(<DiscoveryCityViewComments />)}
                        />

                        <Route
                            path="/discovery/cities"
                            element={requireDiscoveryAccess(<DiscoveryCityList />)}
                        />
                        <Route
                            path="/discovery/cities/:id"
                            element={requireDiscoveryAccess(<DiscoveryCityView />)}
                        />
                        <Route
                            path="/discovery/cities/:id/salary"
                            element={requireDiscoveryAccess(<DiscoveryCityViewSalaries />)}
                        />
                        <Route
                            path="/discovery/cities/:id/insights"
                            element={requireDiscoveryAccess(<DiscoveryCityViewInsights />)}
                        />
                        <Route
                            path="/discovery/cities/:id/universities"
                            element={requireDiscoveryAccess(<DiscoveryCityViewUniversities />)}
                        />
                        <Route
                            path="/discovery/cities/:id/comments"
                            element={requireDiscoveryAccess(<DiscoveryCityViewComments />)}
                        />
                        <Route
                            path="/discovery/cities/:id/companies"
                            element={requireDiscoveryAccess(<DiscoveryCityCompanyList />)}
                        />
                        <Route
                            path="/discovery/cities/:cityId/companies/:companyId"
                            element={requireDiscoveryAccess(<DiscoveryCompanyView />)}
                        />
                        <Route
                            path="/discovery/cities/:cityId/companies/:companyId/jobs"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />
                        <Route
                            path="/discovery/cities/:cityId/companies/:companyId/hiring"
                            element={requireDiscoveryAccess(<DiscoveryCompanyHiringView />)}
                        />
                        <Route
                            path="/discovery/cities/:id/companies/jobs"
                            element={requireDiscoveryAccess(<DiscoveryCityJobsList />)}
                        />
                        <Route
                            path="/discovery/cities/:id/jobs"
                            element={requireDiscoveryAccess(<DiscoveryCityJobsList />)}
                        />
                        <Route
                            path="/discovery/cities/:id/jobs/:companyId"
                            element={requireDiscoveryAccess(<DiscoveryJobsView />)}
                        />

                        {/* Routes for donation */}
                        <Route path="/payment-success" element={<PaymentSuccess />} />
                        <Route path="/payment-cancelled" element={<PaymentCancelled />} />
                        <Route path="/donations-my" element={<DonationsMy />} />
                        <Route path="/donations-list" element={<DonationsList />} />

                        {/* ✅ Magic login route */}
                        <Route path="/magic-login" element={<MagicLogin />} />

                        {/* Support requests (student) */}
                        <Route path="/support" element={requireAuth(<SupportList />)} />
                        <Route path="/support/:id" element={requireAuth(<SupportView />)} />

                        {/* Communities (student) */}
                        <Route path="/communities" element={requireStudentAccess(<Communities />)} />
                        <Route path="/communities/:id" element={requireStudentAccess(<CommunityView />)} />

                        {/* User profile routes */}
                        <Route path="/profile" element={requireAuth(<UserProfileAbout />)} />
                        <Route path="/profile/academics" element={requireAuth(<UserProfileAcademics />)} />
                        <Route path="/profile/work-preferences" element={requireAuth(<UserProfileWorkPreferences />)} />
                        <Route path="/profile/history" element={requireAuth(<UserProfileHistory />)} />

                        {/* Protected Routes for Admin/Superadmin */}
                        <Route path="/onboarding-user-list" element={requireAgreement(<UserList />)} />
                        <Route path="/user-edit/:id" element={requireAgreement(<UserEdit />)} />
                        <Route path="/user-edit-academics/:id" element={requireAgreement(<UserEditAcademics />)} />
                        <Route path="/user-edit-access/:id" element={requireAgreement(<UserEditAccess />)} />
                        <Route path="/user-edit-work-preferences/:id" element={requireAgreement(<UserEditWorkPreferences />)} />
                        <Route path="/user-edit-history/:id" element={requireAgreement(<UserEditHistory />)} />
                        <Route path="/user-add" element={requireAgreement(<UserAdd />)} />
                        <Route path="/onboarding-company-list" element={requireAgreement(<CompanyList />)} />
                        <Route path="/onboarding-country-list" element={requireAgreement(<CountryList />)} />
                        <Route path="/country-add" element={requireAgreement(<CountryAdd />)} />
                        <Route path="/company-add" element={requireAgreement(<CompanyAdd />)} />
                        <Route path="/company-review/:id" element={requireAgreement(<CompanyReview />)} />
                        <Route path="/company-edit/:id" element={requireAgreement(<CompanyEdit />)} />
                        <Route path="/company-edit-hiring/:id" element={requireAgreement(<CompanyEditHiring />)} />
                        <Route path="/company-edit-users/:id" element={<CompanyEditUsers />} />
                        <Route path="/company-edit-history/:id" element={requireAgreement(<CompanyEditHistory />)} />
                        <Route path="/add-company-user" element={requireAgreement(<AddCompanyUser />)} />
                        <Route path="/onboarding-user-list-company" element={requireAgreement(<UserListCompany />)} />
                        <Route path="/country-edit-general/:id" element={requireAgreement(<CountryEditGeneral />)} />
                        <Route path="/country-edit-visa-stay/:id" element={requireAgreement(<CountryEditVisaStay />)} />
                        <Route path="/country-edit-work-tax/:id" element={requireAgreement(<CountryEditWorkTax />)} />
                        <Route path="/country-edit-financials-banks/:id" element={requireAgreement(<CountryEditFinancialsBanks />)} />
                        <Route path="/country-edit-housing-life/:id" element={requireAgreement(<CountryEditHousingLife />)} />
                        <Route path="/country-edit-social/:id" element={requireAgreement(<CountryEditSocial />)} />
                        <Route path="/country-edit-industries/:id" element={requireAgreement(<CountryEditIndustries />)} />
                        <Route path="/city-add" element={requireAgreement(<CityAdd />)} />
                        <Route path="/onboarding-city-list" element={requireAgreement(<CityList />)} />
                        <Route path="/city-edit/:id" element={requireAgreement(<CityEdit />)} />
                        <Route path="/city-edit-salary/:id" element={requireAgreement(<CityEditSalary />)} />
                        <Route path="/city-edit-insights/:id" element={requireAgreement(<CityEditInsights />)} />
                        <Route path="/city-edit-universities/:id" element={requireAgreement(<CityEditUniversities />)} />
                        <Route path="/city-edit-companies/:id" element={requireAgreement(<CityEditCompanies />)} />
                        <Route path="/city-edit-jobs/:id" element={requireAgreement(<CityEditJobs />)} />
                        <Route path="/city-edit-history/:id" element={requireAgreement(<CityEditHistory />)} />
                        <Route path="/city-edit-companies/:cityId/company/:id" element={requireAgreement(<CompanyEdit />)} />
                        <Route path="/city-edit-companies/:cityId/company/:id/hiring" element={requireAgreement(<CompanyEditHiring />)} />
                        <Route path="/city-edit-companies/:cityId/company/:id/users" element={<CompanyEditUsers />} />
                        <Route path="/city-edit-companies/:cityId/company/:id/history" element={requireAgreement(<CompanyEditHistory />)} />
                        <Route path="/city-edit-jobs/:cityId/company/:id" element={requireAgreement(<CompanyEdit />)} />
                        <Route path="/city-edit-jobs/:cityId/company/:id/hiring" element={requireAgreement(<CompanyEditHiring />)} />
                        <Route path="/city-edit-jobs/:cityId/company/:id/users" element={<CompanyEditUsers />} />
                        <Route path="/city-edit-jobs/:cityId/company/:id/history" element={requireAgreement(<CompanyEditHistory />)} />
                        <Route path="/ticket-list" element={requireAgreement(<TicketList />)} />
                        <Route path="/ticket-add" element={requireAgreement(<TicketAdd />)} />
                        <Route path="/ticket-edit/:id" element={requireAgreement(<TicketEdit />)} />
                        <Route path="/mapping-overview" element={requireAgreement(<MappingOverview />)} />
                        <Route path="/mapping-industries" element={requireAgreement(<MappingIndustries />)} />
                        <Route path="/mapping-industries-view" element={requireAgreement(<MappingIndustriesView />)} />
                        <Route path="/mapping-industry/:code/subindustries" element={requireAgreement(<MappingSubIndustriesView />)} />
                        <Route path="/mapping-occupation" element={requireAgreement(<MappingOccupation />)} />
                        <Route path="/mapping-study-fields-view" element={requireAgreement(<MappingStudyFieldsView />)} />
                        <Route path="/mapping-study-fields/:code/subspecialist" element={requireAgreement(<MappingSubSpecialistView />)} />
                        <Route path="/mapping-study-degrees-view" element={requireAgreement(<MappingStudyDegreesView />)} />
                        <Route path="/mapping-occupation-view" element={requireAgreement(<MappingOccupationView />)} />
                        <Route path="/mapping-occupation/:code/suboccupation" element={requireAgreement(<MappingSubOccupationView />)} />

                        {/* Reporting */}
                        <Route path="/reporting/jobs" element={requireAgreement(<ReportingJobsList />)} />
                        <Route path="/reporting/general" element={requireAgreement(<ReportingGeneralList />)} />
                        <Route path="/reporting/users" element={requireAgreement(<ReportingUsersList />)} />
                        <Route path="/reporting/revenue" element={requireAgreement(<ReportingRevenueList />)} />


                        {/* Other Pages */}
                        {/* <Route path="/registration-success" element={<RegistrationSuccess />} />
                        <Route path="/setup-academics" element={<SetupAcademics />} />
                        <Route path="/quick-start" element={<QuickStart />} /> */}

                        </Routes>
                    </div>
                    </MobileAiAssistantProvider>
                </HeaderActionContext.Provider>
            </Router>
        </>
    );
}

export default App;
